export const ONBOARDING_WEB_EVENTS = {
	HOME: 'landing_shown',
	PAYMENT: 'payment_shown',
	EMAIL: 'email',
};
